package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionWebhookEventRepository
import com.clany.backoffice.model.SubscriptionWebhookEventResponse
import dev.zacsweers.metro.Inject

class GetWebhookEventsUseCase @Inject constructor(
    private val repository: SubscriptionWebhookEventRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<SubscriptionWebhookEventResponse>> = repository.getWebhookEvents(page, pageSize, query)
}
